import http from "@/shared/services/http";

export const createCountryV2 = (data: any) => http.post(`v1/regions/countries/create`, data);
export const singleCountryV2 = (id: number) => http.get(`v1/regions/countries/single/${id}`);
export const editCountryV2 = (data: any) => http.put(`v1/regions/countries/edit/${data.id}`, data);
export const listCountryV2 = (params: any = {}) => http.get(`v1/regions/countries/list`, { params });
export const deleteCountryV2 = (id: number) => http.delete(`v1/regions/countries/delete/${id}`);
